import * as React from 'react'

const WorkToolBig = (props) => (
  <svg
    width={96}
    height={85}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.893 12.988c-8.04-8.04-20.08-9.68-29.76-4.96l14.52 14.52a3.983 3.983 0 0 1 0 5.64l-6.36 6.36a3.913 3.913 0 0 1-5.64 0l-14.52-14.52c-4.68 9.72-3.04 21.68 5 29.72 7.44 7.44 18.32 9.4 27.56 5.92l31.84 31.84c4.12 4.12 10.76 4.12 14.84 0 4.12-4.12 4.12-10.76 0-14.84l-31.68-31.72c3.68-9.36 1.76-20.4-5.8-27.96Z"
      fill="#fff"
      opacity={0.32}
    />
  </svg>
)

export default React.memo(WorkToolBig)
